export default "__VITE_ASSET__BRlRTCk3__"